import React from "react";

export function InputField({
  value,
  onChange,
  placeholder,
  unit,
  error,
  min,
  max,
  type = "number",
}) {
  return (
    <div className="flex-1">
      <div className="relative"> {/* New container div */}
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          min={min}
          max={max}
          className={`w-full px-4 py-4 text-lg text-left border rounded-xl focus:outline-none focus:ring-1 focus:ring-green-400 focus:border-green-400 "border-gray-300"`}
        />
        {unit && (
          <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 font-medium">
            {unit}
          </div>
        )}
      </div>
      {error && <p className="mt-1 px-1 text-xs text-gray-400">{error}</p>}
    </div>
  );
}